/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.TextHelper"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.TextHelper", ["require", "exports", "SuiteCommerce.PagePrinter.ItemDetailsLayout.Helper"], function (require, exports, ItemDetailsLayout_Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TextHelper = /** @class */ (function (_super) {
        __extends(TextHelper, _super);
        function TextHelper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        TextHelper.prototype.prepareHelpers = function () {
            this.helpers = [
                {
                    name: 'getFormattedText',
                    helperAction: function (item, field) {
                        var fieldValue = item.get(field.fieldId);
                        var placeholder = field.placeholder;
                        if (placeholder && fieldValue) {
                            fieldValue =
                                placeholder.indexOf('[[value]]') !== -1
                                    ? placeholder.replace('[[value]]', fieldValue)
                                    : placeholder + " " + fieldValue;
                        }
                        return fieldValue;
                    },
                },
                {
                    name: 'sanitizeHtml',
                    helperAction: function (text) {
                        if (text) {
                            var detectStyleInline = /(class|style)="[\w\d\s:;&\."()\-\,]*"/g;
                            return text.replace(detectStyleInline, '');
                        }
                        return null;
                    },
                },
                {
                    name: 'isText',
                    helperAction: function (fieldType) {
                        return fieldType === 'Text';
                    },
                },
            ];
        };
        return TextHelper;
    }(ItemDetailsLayout_Helper_1.Helper));
    exports.TextHelper = TextHelper;
});
